// extracted by mini-css-extract-plugin
module.exports = {"root":"ProcedureTabs_root__3Kgnr","tab":"ProcedureTabs_tab__1ulxR"};